import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const SearchIosAppName = new ReduxAsyncAction<'SEARCH_IOS_APP_NAME', string, { iosAppName: string }>('SEARCH_IOS_APP_NAME');

SearchIosAppName.registerRequest(async (appId: string) => {
  const appIdWithoutIdPrefix = appId.slice(2);

  const response = await fetch(`https://itunes.apple.com/lookup?id=${appIdWithoutIdPrefix}&country=no`, {
    method: 'POST',
  });

  const data = await response.json();
  const iosAppName = data?.results[0]?.trackName;

  return { iosAppName };
});

export const SEARCH_IOS_APP_NAME = SearchIosAppName.actionNamespaceConstants;
export const searchIosAppName = SearchIosAppName.request;

export type SearchIosAppNameResponseAction = Action<typeof SEARCH_IOS_APP_NAME.response> & {
  data: { iosAppName: string };
};
